import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const selectSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.select, {
        base: {
            content: {
                p: 0,
                boxShadow: 'tile',
                borderRadius: 'tile',
                mt: 1,
                borderWidth: 0,
            },
            trigger: {
                justifyContent: 'start',
                borderRadius: 'tileImage',
                cursor: 'pointer',
                _disabled: {
                    cursor: 'default',
                },
            },
            indicator: {
                transition: 'transform .3s',
                color: {
                    base: 'secondary.600',
                    _disabled: 'fg.subtle',
                    _invalid: 'fg.error',
                },
                transform: {
                    _open: 'scale(-1)',
                },
            },
            item: {
                cursor: 'pointer',
                _icon: {
                    width: 4,
                    height: 4,
                    color: 'secondary.600',
                },

                _highlighted: {
                    bg: 'secondary.100',
                },
                _checked: {
                    fontWeight: 'bold',
                },
            },
        },

        variants: {
            size: {
                lg: {
                    '--select-trigger-height': '46px',
                    content: {
                        p: 0,
                    },
                    item: {
                        pl: 11,
                        pr: 4,
                        py: 3,
                    },
                },
            },
            variant: {
                outline: {
                    content: {
                        borderWidth: '1px',
                    },
                },
                clean: {
                    item: {
                        borderRadius: 0,
                        '&:not(:last-child)': {
                            borderBottomWidth: '1px',
                        },
                    },
                },
            },
        },
    }),
);
